import { generatePath } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import { URL_PAGE_CATALOG_2ND_LVL } from '@shared/contants'
import { CategoriesPreviewQuery } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import LinkChip from '@shared/ui/link-chip'

import styles from './styles.module.scss'

interface CarouselPreviewProps {
  data: CategoriesPreviewQuery;
  parentCategorySlug: string;
  className?: string;
}

export default function CarouselCategoriesPreview (props: CarouselPreviewProps) {
  const { data, parentCategorySlug, className } = props
  const isMobile = useMediaQuery('(max-width: 639px)')

  const categories = data.categories ?? []

  const makePath = (slug: string) => generatePath(URL_PAGE_CATALOG_2ND_LVL, {
    categorySlug: parentCategorySlug,
    categoryChildrenSlug: slug
  })

  if (isMobile) {
    const half = Math.ceil(categories.length / 2)
    const firstColumn = categories.slice(0, half)
    const secondColumn = categories.slice(half)

    return (
      <div
        className={cn(styles.root, className)}
        style={{ display: 'flex', gap: '8px' }}
      >
        <div className={styles.root__col}>
          {firstColumn.map((item) => (
            <LinkChip
              to={makePath(item?.slug as string)}
              key={item?.id}
            >
              {item?.name}
            </LinkChip>
          ))}
        </div>
        <div className={styles.root__col}>
          {secondColumn.map((item) => (
            <LinkChip
              to={makePath(item?.slug as string)}
              key={item?.id}
            >
              {item?.name}
            </LinkChip>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className={cn(styles.root, className)}>
      {categories.map((item) => (
        <LinkChip
          to={makePath(item?.slug as string)}
          key={item?.id}
        >
          {item?.name}
        </LinkChip>
      ))}
    </div>
  )
}
